import { useEffect } from 'react'
import { useCountUnreadIncoming } from './useCountUnreadIncoming'
import { useCountUnreadOutgoing } from './useCountUnreadOutgoing'

export const useCountUnreadAll = () => {
  const incoming = useCountUnreadIncoming()
  const outgoing = useCountUnreadOutgoing()

  const countUnread = (incoming.data !== undefined && outgoing.data !== undefined) ? incoming.data + outgoing.data : 0
  const loading = incoming.loading || outgoing.loading
  const error = incoming.error + outgoing.error

  const fetchUnread = () => {
    incoming.fetchData()
    outgoing.fetchData()
  }
  useEffect(() => {
    fetchUnread()
  }, [])

  return { countUnread, fetchUnread }
}